import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function VetSignOut() {
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        await fetch('/api/vet-auth/sign-out', { method: 'POST', credentials: 'include' });
      } catch {
        /* ignore */
      }
      navigate('/sign-in', { replace: true });
    })();
  }, [navigate]);
  return (
    <div className="min-h-[100dvh] flex items-center justify-center text-zinc-500">
      Signing out…
    </div>
  );
}
